import { useMutation } from '@apollo/client'
import { ImageUpdateDocument } from '../../../../../graphql/generated'
import useAlerts from '../../../hooks/useAlerts'

export default function useUpdateImage() {
  const { createAlert } = useAlerts()
  const [mutation, results] = useMutation(ImageUpdateDocument, {
    onError: () => {
      createAlert('There was a problem updating image settings. Please try again later.')
    },
    onCompleted: () => {
      createAlert('Image settings have been updated', 'success')
    },
    update: (cache) => {
      // Waiting 2 seconds because if user updates image details in search view kafka can take longer
      // than the eviction and refetching of the query serachImages. User will not see the delay.
      setTimeout(() => {
        cache.evict({ id: `ROOT_QUERY`, fieldName: 'searchImages' })
      }, 2000)
    }
  })

  return { mutation, results }
}
